// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=ltr] .dropdown-text[data-v-2b529b19] {\n  margin-left: 5px;\n}[dir=rtl] .dropdown-text[data-v-2b529b19] {\n  margin-right: 5px;\n}\n.pdv-dropdown[data-v-2b529b19] {\n  width: 90px;\n  height: 90px;\n}\n[dir] .pdv-dropdown[data-v-2b529b19] {\n  padding: 0;\n}", ""]);
// Exports
module.exports = exports;
